import React, { useState } from 'react';
import { assistFormApiCall } from '../../cabsAPIs';
import { HelpForm } from '@gommt-cabs/ui-lib';

interface CouponData {
  couponCode: string;
  subTitle: string;
  title: string;
}

interface TripAssistantProps {
  trackEvent: (eventName: string) => void;
  autoOpenDelay: number;
  source?: string;
  destination?: string;
  couponData?: CouponData | null;
  showTripAssistant?: boolean;
  showLeaveIntentForm?: boolean;
}

const TripAssistant = ({
  trackEvent,
  autoOpenDelay,
  source,
  destination,
  couponData,
  showTripAssistant,
  showLeaveIntentForm
}: TripAssistantProps) => {
  const [formState, setFormState] = useState({
    isSubmitted: false,
    hasError: false
  });

  const formSubmitCall = async (phoneNumber: string) => {
    const assistedFormRequest = {
      source: source || '',
      destination: destination || '',
      travel_date: '',
      name: '',
      mobile: phoneNumber,
      special_request: '',
      type: 'seoAssistedFlowRequest'
    };

    try {
      const response = await assistFormApiCall(assistedFormRequest);
      //Catch errors coming in successful api response
      if (response['errors']) {
        setFormState({
          isSubmitted: true,
          hasError: true
        });
      } else {
        setFormState({
          isSubmitted: true,
          hasError: false
        });
      }
    } catch (error) {
      setFormState({
        isSubmitted: true,
        hasError: true
      });
    }
  };

  return (
    <HelpForm
      trackEvent={trackEvent}
      onSubmit={formSubmitCall}
      formState={formState}
      setFormState={setFormState}
      pageName="SEO"
      autoOpenDelay={autoOpenDelay}
      couponInfo={couponData}
      showAssistantIcon={showTripAssistant}
      showLeaveIntentForm={showLeaveIntentForm}
    />
  );
};

export default TripAssistant;
